import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from '../../../environments/environment';
import { CurrentUser } from '../current-user.model';
import { CurrentUserService } from "../current-user.service";

@Component({
  selector: 'loginout',
  templateUrl: './loginout.component.html',
  styleUrls: ['./loginout.component.css']
})
export class LogInOutComponent implements OnInit {

  constructor(private currentUserService: CurrentUserService,
    private router: Router, route: ActivatedRoute) {
  }

  private myUrl = '';

  ngOnInit(): void {
    //console.log("loginout component ngOnInit");
    //console.log('window location=' + window.location.href);

    this.myUrl = window.location.href;

    if (!this.currentUserService.browserOk) {
      this.currentUserService.browserCheck().then(response => { });
    }

    this.currentUserService.login().then(response => {
    });
  }

  logIn(login: boolean = true) {
    this.currentUserService.browserLogin(login);
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/security/loginout/loginout.component.ts